import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { IonicBaseComponent } from '@front-end/core/ionic-hooks';
import { ModalController } from '@ionic/angular';
import { CheckboxListOption } from '../checkbox-list/abstract-checkbox-list.component';
import {
  FundCashDateOptionEnum,
  FundCashStatusFilterEnum,
  normalizeFundCashFilters,
} from '../fund-cash-filters/fund-cash-filters.component';

@Component({
  selector: 'ui-fund-cash-filters-modal',
  templateUrl: './fund-cash-filters-modal.component.html',
  styleUrls: ['./fund-cash-filters-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FundCashFiltersModalComponent extends IonicBaseComponent {
  readonly statusOptions: CheckboxListOption[] = [
    {
      label: 'pages.fund-cash.filters.fields.status.title',
      options: [
        {
          label: 'pages.fund-cash.filters.fields.status.all',
          value: undefined,
        },
        {
          label: 'pages.fund-cash.payment-status.authorized',
          value: FundCashStatusFilterEnum.AUTHORIZED,
        },
        {
          label: 'pages.fund-cash.payment-status.paid',
          value: FundCashStatusFilterEnum.PAID,
        },
        {
          label: 'pages.fund-cash.status.transferred',
          value: FundCashStatusFilterEnum.TRANSFERRED,
        },
      ],
    },
  ];

  readonly dateOptions: CheckboxListOption[] = [
    {
      label: 'pages.fund-cash.filters.fields.date.title',
      options: [
        {
          label: 'quote.filters.fields.date.lastWeek',
          value: FundCashDateOptionEnum.LAST_WEEK,
        },
        {
          label: 'quote.filters.fields.date.lastMonth',
          value: FundCashDateOptionEnum.LAST_MONTH,
        },
        {
          label: 'quote.filters.fields.date.lastSemester',
          value: FundCashDateOptionEnum.LAST_SEMESTER,
        },
        {
          label: 'quote.filters.fields.date.all',
          value: undefined,
        },
      ],
    },
  ];

  readonly form = this.formBuilder.group({
    status: this.formBuilder.control<(FundCashStatusFilterEnum | undefined)[]>([
      undefined,
    ]),
    date: this.formBuilder.control<(FundCashDateOptionEnum | undefined)[]>([
      undefined,
    ]),
  });

  @Input() set filters(value: {
    status?: (FundCashStatusFilterEnum | undefined)[];
    date?: (FundCashDateOptionEnum | undefined)[];
  }) {
    const nextFilters = normalizeFundCashFilters(value);

    this.form.patchValue(
      {
        status: nextFilters.status,
        date: nextFilters.date,
      },
      { emitEvent: false }
    );
  }

  constructor(
    private modalController: ModalController,
    private formBuilder: FormBuilder
  ) {
    super();
  }

  confirm(): void {
    this.modalController.dismiss(
      normalizeFundCashFilters(this.form.getRawValue())
    );
  }

  close(): void {
    this.modalController.dismiss();
  }
}
